module.exports = __webpack_public_path__ + "img/quanjinditu.1749b917.png";